
//! This file was generated by a tool
//! Any changes made to this file will be overwritten.


import slide0 from "./git-hooks.ts";
import slide1 from "./quiz.ts";
import slide2 from "./sample.ts";
import slide3 from "./umbreacto.ts";
const slides = [slide0,slide1,slide2,slide3,];
export default slides;